<template>
  <CreateSave
      :maxWidth="500"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :createData="createData"
      @onCreate="(response) => $emit('onCreateIndexGroup', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.title"
              :error-messages="errors.title"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Názov"
          />
        </v-col>
      </v-row>
    </template>
  </CreateSave>
</template>

<script>
  import Indexes from '@/services/indexes'

  import CreateSave from '@/components/_Part/_Modal/_Save/Create'

  export default {
    name: 'CreateIndexGroup',
    props: [
      'indexGroupId'
    ],
    emits: [
      'onCreateIndexGroup'
    ],
    components: {
      CreateSave
    },
    methods: {
      setTitle() {
        return 'Vytvoriť číselník'
      },
      setItemForm() {
        return {
          title: null
        }
      },
      createData(ItemForm) {
        return Indexes
          .createIndexGroup({
            indexGroupId: this.indexGroupId,
            data: ItemForm
          })
      }
    }
  }
</script>
